import React, { useState, useEffect } from "react";

const OtpInput = ({ length = 6, onComplete, codeInputTestId }) => {
  const [otp, setOtp] = useState(Array(length).fill(""));

  const handleChange = (value, index) => {
    if (isNaN(value)) return; // Allow only numeric input

    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1); // Ensure only one character is entered
    setOtp(newOtp);

    // Move focus to the next input
    if (value && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      e.preventDefault();
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      // Move focus to the previous input
      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = [...otp];
    for (let i = 0; i < pasteData.length; i++) {
      if (!isNaN(pasteData[i])) {
        newOtp[i] = pasteData[i];
      }
    }
    setOtp(newOtp);

    // Move focus to the last filled input
    const lastIndex = Math.min(pasteData.length, length) - 1;
    if (lastIndex >= 0) {
      document.getElementById(`otp-input-${lastIndex}`).focus();
    }
  };

  useEffect(() => {
    if (otp.every((val) => val !== "")) {
      onComplete(otp.join(""));
    }
  }, [otp, onComplete]);

  return (
    <div className="otpContainer" onPaste={handlePaste} data-testid={codeInputTestId}>
      {otp.map((value, index) => (
        <input
          key={index}
          id={`otp-input-${index}`}
          data-testid={codeInputTestId ? `${codeInputTestId}-${index}` : undefined}
          className="otpInput"
          type="text"
          maxLength={1}
          value={value}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onFocus={(e) => e.target.select()}
        />
      ))}
    </div>
  );
};

export default OtpInput;
